import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarHome = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.155 2.743a3.7 3.7 0 0 1 3.69 0l5.922 3.412A3.7 3.7 0 0 1 21.62 9.36v9.147c0 1.79-1.449 3.24-3.238 3.243l-1.087.001a3.066 3.066 0 0 1-3.068-3.067v-3.262a2.197 2.197 0 0 0-2.197-2.197h-.057a2.197 2.197 0 0 0-2.197 2.197v3.262a3.066 3.066 0 0 1-3.069 3.067l-1.086-.001a3.243 3.243 0 0 1-3.24-3.243V9.36c0-1.322.706-2.544 1.852-3.204zm.748 1.3L4.981 7.455a2.2 2.2 0 0 0-1.1 1.904v9.147c0 .962.778 1.742 1.74 1.743l1.087.001c.864 0 1.567-.7 1.567-1.567v-3.262a3.697 3.697 0 0 1 3.697-3.697h.057a3.697 3.697 0 0 1 3.697 3.697v3.262c0 .867.701 1.568 1.567 1.567l1.085-.001a1.743 1.743 0 0 0 1.741-1.743V9.36c0-.786-.419-1.512-1.1-1.903l-5.922-3.413a2.2 2.2 0 0 0-2.194 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarHome);
export default ForwardRef;
